import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Page, Banner } from '@shopify/polaris';
import FilterTableProvider from '@container/FilterTableProvider';

import { returnIndexColumns } from 'utils/recordHelpers'

const propTypes = {
  records: PropTypes.array.isRequired,
  isAdmin: PropTypes.bool,
  filterURL: PropTypes.string.isRequired,

  sellers: PropTypes.array,
};

const SaleReportIndex = (props) => {
  const { sellers, totalPages, records } = props;

  return (
    <FilterTableProvider
      pageProps={{
        title: I18n.t("transfer_return.other"),
      }}
      users={ sellers }

      filterByCreation={false}
      paramsName="filters"
      filterURL={ props.filterURL }
      itemURL="/logs/returns_report"
  
      initialFilters={{
        user_id: (sellers.length > 0) && sellers[0].value,
      }}
      initialRecords={ records }
      columnsInfo={ returnIndexColumns }

      initialTotalPages={ totalPages }
      legacy={ false }
    >
    </FilterTableProvider>
  );
}

SaleReportIndex.propTypes = propTypes;


export default SaleReportIndex;
